import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { useStylesBase } from '../useStylesBase.js';

export const FormTitle = (props) => {
  const { type, contactNumbers, setContactNumbers, emails, setEmails, addresses, setAddresses } =
    props;

  const baseClasses = useStylesBase();
  const clickAddItem = () => {
    if (type === 'contactNumber') {
      let count = 0;
      const contactNumbersMirror = [];
      contactNumbers.forEach((contactNumber) => {
        if (contactNumber.id) {
          count++;
        }
        contactNumbersMirror.push(contactNumber);
      });
      contactNumbersMirror.push({
        preferred: 'false',
        type: 'Personal',
        value: '',
      });
      if (contactNumbersMirror.length - count === 1) {
        setContactNumbers(contactNumbersMirror);
      }
    } else if (type === 'email') {
      let count = 0;
      const emailsMirror = [];
      emails.forEach((email) => {
        if (email.id) {
          count++;
        }
        emailsMirror.push(email);
      });

      emailsMirror.push({
        preferred: 'false',
        type: 'Personal',
        value: '',
      });
      if (emailsMirror.length - count === 1) {
        setEmails(emailsMirror);
      }
    } else {
      let count = 0;
      const addressesMirror = [];
      addresses.forEach((address) => {
        if (address.id) {
          count++;
        }
        addressesMirror.push(address);
      });
      addressesMirror.push({
        type: 'Personal',
        unit: '',
        block: '',
        street: '',
        postalCode: '',
        locality: '',
        city: '',
        buildingName: '',
        country: '',
        region: '',
        location: '',
        preferred: 'false',
        level: '',
        tempUnit: '',
      });
      if (addressesMirror.length - count === 1) {
        setAddresses(addressesMirror);
      }
    }
  };

  const item = (() => {
    let title, buttonText;
    if (type === 'contactNumber') {
      title = 'Contact Number';
      buttonText = 'Add New Contact Number';
    } else if (type === 'email') {
      title = 'Email Address';
      buttonText = 'Add New Email';
    } else {
      title = 'Address Detail';
      buttonText = 'Add New Address';
    }
    return { title, buttonText };
  })();
  return (
    <Typography component="h3" variant="subtitle2" className={baseClasses.formTitle}>
      {item.title}
      <div data-testid={`set-${type}`} onClick={clickAddItem}>
        <Add alt="addItem" />
        {item.buttonText}
      </div>
    </Typography>
  );
};

FormTitle.propTypes = {
  type: PropTypes.string,
  contactNumbers: PropTypes.array,
  setContactNumbers: PropTypes.func,
  emails: PropTypes.array,
  setEmails: PropTypes.func,
  addresses: PropTypes.array,
  setAddresses: PropTypes.func,
};
